// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content[data-v-f4afa1a4]{\n  overflow:hidden;\n  white-space:nowrap; /*不允许换行*/\n  text-overflow:ellipsis;/*超出部分省略号显示*/\n  cursor: pointer;\n}\n", ""]);
